
import { ReportId } from "./reports";

export const PAGE_REPORTS: Record<string, ReportId[]> = {
  partneredSummary: ["consolidated_reports_partnered",
    "order_summary_partnered",
    "returnable_product_detail_partnered",
    "non_returnable_product_detail_partnered",
    "schedule_ii_product_detail_partnered",
    "schedule_iii_v_product_detail_partnered",
    "legend_and_otc_product_detail_partnered",
    "write_off_letter" ],
  nonPartneredSummary: ["consolidated_reports_nonpartnered",    
    "order_summary_nonpartnered",
    "returnable_product_detail_nonpartnered",
    "non_returnable_product_detail_nonpartnered",    
    "schedule_ii_product_detail_nonpartnered",
    "schedule_iii_v_product_detail_nonpartnered",
     "legend_and_otc_product_detail_nonpartnered",
     "manufacturer_debit_list",
    "write_off_letter" ],
  rcp: ["consolidated_reports_rcp",
    "order_summary_rcp",
    "returnable_product_detail_rcp",
    "non_returnable_product_detail_rcp", 
    "schedule_ii_product_detail_rcp",   
    "schedule_iii_v_product_detail_rcp",
     "legend_and_otc_product_detail_rcp",    
    "write_off_letter"],
};

export const REPORT_META: Partial<Record<ReportId, { fileName?: string }>> = {
  returnable_product_detail_partnered: {
    fileName: "Returnable Product Detail",
  },
  returnable_product_detail_nonpartnered: {
    fileName: "Returnable Product Detail",
  },
  returnable_product_detail_rcp: {
    fileName: "Returnable Product Detail",
  },
  order_summary_partnered: {
    fileName: "Order Summary",
  },
  order_summary_nonpartnered: {
    fileName: "Order Summary",
  },  
  order_summary_rcp: {
    fileName: "Order Summary",
  },
  non_returnable_product_detail_partnered: {
    fileName: "Non-Returnable Product Detail",
  },
  non_returnable_product_detail_nonpartnered: {
    fileName: "Non-Returnable Product Detail",
  },
  non_returnable_product_detail_rcp: {
    fileName: "Non-Returnable Product Detail",
  },
  schedule_ii_product_detail_partnered: {
    fileName: "Schedule II Product Detail",
  }, 
  schedule_ii_product_detail_nonpartnered: {
    fileName: "Schedule II Product Detail",
  },
  schedule_ii_product_detail_rcp: {
    fileName: "Schedule II Product Detail",
  },
schedule_iii_v_product_detail_partnered: {
    fileName: "Schedule III-V Product Detail",
  },
  schedule_iii_v_product_detail_nonpartnered: {
    fileName: "Schedule III-V Product Detail",
  },
  schedule_iii_v_product_detail_rcp: {
    fileName: "Schedule III-V Product Detail",
  },
legend_and_otc_product_detail_partnered: {
    fileName: "Legend and OTC Product Detail",
  },   
legend_and_otc_product_detail_nonpartnered: {
    fileName: "Legend and OTC Product Detail",
  },
  legend_and_otc_product_detail_rcp: {
    fileName: "Legend and OTC Product Detail",
  },
consolidated_reports_partnered: {     
    fileName: "Consolidated Report",
  },
  consolidated_reports_nonpartnered: {   
    fileName: "Consolidated Report",
  },
  consolidated_reports_rcp: {   
    fileName: "Consolidated Report",
  }, 
};
